module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Melinda Roth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Melinda Roth")]), _vm._v(" has worked as a state political correspondent and feature writer for the"), _c('I', [_vm._v("St. Louis Riverfront Times")]), _vm._v(" and as the education reporter for the "), _c('I', [_vm._v("Edwardsville Intelligencer. ")]), _vm._v("Raised in the Chicagoland area, she has three children and two rescued dogs.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sGtfRk/e9781466822931_cover.jpg?1727387913519",
      "alt": "This image is the cover for the book Man Who Talks to Dogs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Man Who Talks to Dogs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Go to any unpopulated or abandoned area in any given urban setting, and you'll find them. Thousands and thousands of wild dogs-abandoned to disease, starvation, and inevitable death-are leading short and brutal lives in the no-man's-land between domestication and wildness, byproducts of the human destitution around them. A lucky few are saved by dedicated rescuers, and Randy Grim, has emerged as one of the country's leading dog saviors. After years of rescuing dogs on his own, he founded Stray Rescue of St. Louis, an organization dedicated to rescue and rehabilitation. "), _c('br'), _c('br'), _vm._v("These are dogs that belong to no one, the ones animal-control experts can't catch and humane shelters won't deal with. They are stray or feral, either abandoned or born wild on the streets, which means they won't come near humans and statistically won't live past their second year. And their numbers are growing every day."), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("The Man Who Talks to Dogs")]), _vm._v(", journalist Melinda Roth narrates Grim's dramatic, inspiring efforts and tells the horrific and heartwarming stories of the dogs he saves, showing how this growing national health problem-controlled by no federal or local regulations-can no longer be ignored.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0